import { render, staticRenderFns } from "./AppStoreMessages.vue?vue&type=template&id=44b79e6a"
import script from "./AppStoreMessages.vue?vue&type=script&lang=js"
export * from "./AppStoreMessages.vue?vue&type=script&lang=js"
import style0 from "./AppStoreMessages.vue?vue&type=style&index=0&id=44b79e6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports